import { api } from "@";
import { searchValuesPayload } from "./helpers";

// Fetch recurring payment with pagination and search filters
export const getRecurringPayment = (page = 1, perSize = "", search) =>
  api.post(
    `/api/RecurringOrder/search`,
    searchValuesPayload({ ...search, page, perSize }),
  );

// Toggle active status of a recurring payment
export const toggleActive = (id, value) =>
  api.patch(`/api/RecurringOrder/${id}/stop-recurring?isStopped=${value}`);
